import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { IModel, ServiceNowObjectDataset } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ServiceNowObjectDataset),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class ServiceNowObjectDatasetAdapter extends TabularTypeDatasetAdapter<ServiceNowObjectDataset, Model.DatasetResource> {
    protected model(): IModel {
        return ServiceNowObjectDataset.MODEL;
    }

    protected async _toResource(dataset: ServiceNowObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, this.model().name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ServiceNowObjectDataset): Promise<ServiceNowObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, this.model());
    }
}
